import { Button, Col, DatePicker, Form, Input, Modal, notification, Row, Select, Spin } from 'antd';
import React from "react";
import moment from "moment";
import StatusTimeline from "./status_timeline";

const { TextArea } = Input;

// System reserved status names that must never appear in the "Add new Status" dropdown (mirrors backend StatusService).
const RESERVED_STATUS_NAMES = ['New', 'Closed', 'Cancelled', 'Reopened', 'Open', 'Done', 'Uncancelled'];
const isReservedStatus = (name) =>
  Boolean(name) && RESERVED_STATUS_NAMES.some((reserved) => reserved.toLowerCase() === String(name).trim().toLowerCase());

class Create extends React.Component {
  constructor() {
    super();
    this.state = {
      showManpower: '',
      user: {},
      formVisible: false,
      showNewTargetDate: false,
      notificationKey: null,
      storedReviewDate: null,
    }
    this.newTargetDateRef = null;
  }

  toggleFormVisible = () => {
    // Close notification if it exists when closing modal
    if (this.state.notificationKey) {
      notification.close(this.state.notificationKey);
    }
    this.setState({
      formVisible: !this.state.formVisible,
      showNewTargetDate: false,
      notificationKey: null,
      storedReviewDate: null,
    })
  };

  componentDidMount() {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
    const user = JSON.parse(localStorage.getItem('user'));
    this.setState({ user });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && !this.state.user && JSON.stringify(this.state.user) === '{}') {
      const user = JSON.parse(localStorage.getItem('user'));
      this.setState({ user });
    }
  }


  handleSubmit = (e) => {
    const { match, data } = this.props;
    e.preventDefault();
    const backToModule = this.props.location.search.split("=")[1];
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }

      // Validate review date against target date
      const targetDate = data && data.expectedDateOfCompletion ? moment(data.expectedDateOfCompletion) : moment();
      // Use form value if exists, otherwise use stored review date
      const reviewDate = values.changeStatus && values.changeStatus['reviewDate']
        ? moment(values.changeStatus['reviewDate'])
        : (this.state.storedReviewDate ? moment(this.state.storedReviewDate) : null);

      if (reviewDate && reviewDate.isAfter(targetDate, 'day')) {
        // Check if new target date is provided
        const newTargetDate = values.changeStatus && values.changeStatus['newTargetDate'] ? moment(values.changeStatus['newTargetDate']) : null;
        if (!newTargetDate) {
          notification.error({
            message: 'Validation Error',
            description: 'New Target Date is required when review date is after the target date.',
            duration: 4,
          });
          // Focus on new target date field
          if (this.newTargetDateRef) {
            setTimeout(() => {
              if (this.newTargetDateRef.focus) {
                this.newTargetDateRef.focus();
              } else if (this.newTargetDateRef.input && this.newTargetDateRef.input.focus) {
                this.newTargetDateRef.input.focus();
              }
            }, 200);
          }
          return;
        }
        // Validate that new target date is on or after review date
        if (newTargetDate.isBefore(reviewDate, 'day')) {
          notification.error({
            message: 'Validation Error',
            description: 'New Target Date must be on or after the Review Date.',
            duration: 4,
          });
          // Focus on new target date field
          if (this.newTargetDateRef) {
            setTimeout(() => {
              if (this.newTargetDateRef.focus) {
                this.newTargetDateRef.focus();
              } else if (this.newTargetDateRef.input && this.newTargetDateRef.input.focus) {
                this.newTargetDateRef.input.focus();
              }
            }, 200);
          }
          return;
        }
      }

      // console.log(values);
      if (match.params && match.params.id) {
        if (backToModule === 'jobcard') {
          const urlBackToJobCard = `/job-card/report/${match.params.id}`;
          this.props.onSubmit(values, match.params.id, urlBackToJobCard);
        } else {
          this.props.onSubmit(values, match.params.id);
        }
      } else {
        this.props.onSubmit(values);
      }
      this.toggleFormVisible();
    });
  };

  searchManpower = (id, searchString) => {
    this.setState({ showManpower: id });
    this.props.searchManpower(searchString)
  };

  handleReviewDateChange = (date) => {
    const { data, form } = this.props;
    const targetDate = data && data.expectedDateOfCompletion ? moment(data.expectedDateOfCompletion) : moment();

    if (date && date.isAfter(targetDate, 'day')) {
      // Check if new target date is already set
      const newTargetDateValue = form.getFieldValue("changeStatus['newTargetDate']");
      const newTargetDate = newTargetDateValue ? moment(newTargetDateValue) : null;

      // If new target date is set, validate it against the review date
      if (newTargetDate && newTargetDate.isBefore(date, 'day')) {
        notification.error({
          message: 'Invalid New Target Date',
          description: 'New Target Date must be on or after the Review Date. Please update the new target date.',
          duration: 4,
        });
        // Clear the invalid new target date
        form.setFieldsValue({
          "changeStatus['newTargetDate']": undefined
        });
        // Update stored review date
        this.setState({ storedReviewDate: date });
        return;
      }

      // If new target date is not set yet, show alert and clear review date
      if (!newTargetDate) {
        const key = `new-target-date-${Date.now()}`;
        notification.warning({
          message: 'Review Date After Target Date',
          description: `Review date is after the target date ${moment(targetDate).format('DD-MM-YYYY')}. Please enter a new target date that is on or after the review date.`,
          duration: 0,
          closable: true,
          key: key,
        });
        this.setState({
          showNewTargetDate: true,
          notificationKey: key,
          storedReviewDate: date
        });
        // Clear the review date to force user to enter it again after filling new target date
        form.setFieldsValue({
          "changeStatus['reviewDate']": undefined
        });
        // Focus on new target date field
        setTimeout(() => {
          if (this.newTargetDateRef) {
            if (this.newTargetDateRef.focus) {
              this.newTargetDateRef.focus();
            } else if (this.newTargetDateRef.input && this.newTargetDateRef.input.focus) {
              this.newTargetDateRef.input.focus();
            }
          }
        }, 200);
      } else {
        // New target date is set and valid, just update stored review date
        this.setState({ storedReviewDate: date });
      }
    } else {
      this.setState({
        showNewTargetDate: false,
        storedReviewDate: null
      });
      // Close notification if it exists
      if (this.state.notificationKey) {
        notification.close(this.state.notificationKey);
        this.setState({ notificationKey: null });
      }
      // Clear the new target date field if review date is not after target date
      form.setFieldsValue({
        "changeStatus['newTargetDate']": undefined
      });
    }
  };

  handleNewTargetDateChange = (date) => {
    const { form } = this.props;
    const reviewDateValue = form.getFieldValue("changeStatus['reviewDate']");
    const reviewDate = reviewDateValue ? moment(reviewDateValue) : this.state.storedReviewDate;

    if (date && reviewDate && date.isBefore(reviewDate, 'day')) {
      notification.error({
        message: 'Invalid New Target Date',
        description: 'New Target Date must be on or after the Review Date.',
        duration: 4,
      });
      // Clear the invalid new target date
      form.setFieldsValue({
        "changeStatus['newTargetDate']": undefined
      });
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { showManpower, user, showNewTargetDate } = this.state;
    const { data, loading, filters, title, resource, form, searchManpower, manpower, status } = this.props;
    // const changeStatusLength = (data && data.changeStatus && data.changeStatus.length) || 0;
    (data && data.changeStatus || []).forEach(item => {
      const status = item.status || {};
      if (status && status.name && status.name === 'ClosedPendingInvoice') {
        item.status.name = 'Closed - Pending Invoice';
      } else if (status && status.name && status.name === 'ClosedPendingInvoiceReopen') {
        item.status.name = 'Closed - Pending Invoice - Reopened';
      } else if (item.status) {
        item.status.name = status && status.name || '--';
      }
    });
    // console.log('data', data);

    const targetDate = data && data.expectedDateOfCompletion ? moment(data.expectedDateOfCompletion) : moment();
    // When the job card is currently 'Closed Pending Invoice', only statuses flagged allowedInClosedPendingInvoice can be added.
    const isClosedPendingInvoice = Boolean(data) && (data.statusTitle || '').trim() === 'ClosedPendingInvoice';
    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
    };

    return (
      <Spin spinning={loading}>
        {data && data.status && data.status !== 'Cancelled' ?
          <Row>
            <Col span={12}>&nbsp;</Col>
            <Col span={12}> <Button style={{ float: 'right' }} className='float-right' type="primary"
              onClick={this.toggleFormVisible}>Add new
              Status</Button></Col>
          </Row> : ''}

        <StatusTimeline title={`Previous Records`} data={data.changeStatus || []} />
        <Modal
          visible={this.state.formVisible}
          title="Add new Status"
          okText="Update"
          onCancel={this.toggleFormVisible}
          onOk={this.handleSubmit}
        >
          <Form layout="vertical">
            {data && data.status && data.status !== 'Cancelled' ?
              <>
                <div key={`status-form`} style={style}>
                  <h4 className='text-muted text-right'>Target Date: <small>{targetDate.format('DD-MM-YYYY HH:mm:ss')}</small></h4>
                  <div>
                    <Form.Item key={`date`} label={'Date'}>
                      {getFieldDecorator(`changeStatus['date']`, {
                        rules: [{ required: true, message: `Date is required!` }],
                        initialValue: moment(),
                      })(<DatePicker disabled />)
                      }
                    </Form.Item>

                    {showNewTargetDate && (
                      <Form.Item key={`new-target-date`} label={'New Target Date (New Completion Date)'}>
                        {getFieldDecorator(`changeStatus['newTargetDate']`, {
                          rules: [
                            { required: true, message: `New Target Date is required!` },
                            {
                              validator: (rule, value, callback) => {
                                if (!value) {
                                  callback();
                                  return;
                                }
                                const reviewDateValue = form.getFieldValue("changeStatus['reviewDate']");
                                const reviewDate = reviewDateValue ? moment(reviewDateValue) : this.state.storedReviewDate;
                                if (reviewDate && moment(value).isBefore(reviewDate, 'day')) {
                                  callback('New Target Date must be on or after the Review Date.');
                                } else {
                                  callback();
                                }
                              }
                            }
                          ],
                        })(<DatePicker
                          ref={(ref) => {
                            if (ref) {
                              this.newTargetDateRef = ref.input || ref;
                            }
                          }}
                          autoFocus={showNewTargetDate}
                          onChange={this.handleNewTargetDateChange}
                          disabledDate={(current) => {
                            const reviewDateValue = form.getFieldValue("changeStatus['reviewDate']");
                            const reviewDate = reviewDateValue ? moment(reviewDateValue) : this.state.storedReviewDate;
                            if (reviewDate) {
                              return current && current.isBefore(reviewDate, 'day');
                            }
                            return false;
                          }}
                        />)
                        }
                      </Form.Item>
                    )}

                    <Form.Item key={`review-date`} label={'Review Date'}>
                      {getFieldDecorator(`changeStatus['reviewDate']`, {
                        rules: [
                          { required: true, message: `Review Date is required!` },
                          {
                            validator: (rule, value, callback) => {
                              if (!value) {
                                callback();
                                return;
                              }
                              // If target date is in the future, allow from today; otherwise from target date
                              const today = moment().startOf('day');
                              const minDate = targetDate.isAfter(today, 'day') ? today : targetDate;
                              if (moment(value).isBefore(minDate, 'day')) {
                                callback(`Review Date must be on or after ${minDate.format('DD-MM-YYYY')}.`);
                              } else {
                                callback();
                              }
                            }
                          }
                        ],
                        // initialValue: '',
                      })(<DatePicker
                        onChange={this.handleReviewDateChange}
                        disabledDate={(current) => {
                          // If target date is in the future, allow from today; otherwise from target date
                          const today = moment().startOf('day');
                          const minDate = targetDate.isAfter(today, 'day') ? today : targetDate;
                          return current && current.isBefore(minDate, 'day');
                        }}
                      />)
                      }
                    </Form.Item>

                    <Form.Item key={`updated-by`} label={'Updated By'}>
                      {getFieldDecorator(`changeStatus['updatedBy']`, {
                        rules: [{ required: true, message: `Updated By` }],
                        initialValue: user && user._id,
                      })(<Select
                        showSearch
                        disabled
                        filterOption={(input, option) =>
                          (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                        }
                        style={{ width: '100%' }}
                        placeholder="Please select"
                      >
                        <Select.Option key={user && user._id}
                          value={user && user._id}>{user && user.name}</Select.Option>
                      </Select>)
                      }
                    </Form.Item>

                    <Form.Item key={`status`} label={'Select Status'}>
                      {getFieldDecorator(`changeStatus['status']`, {
                        rules: [{ required: true, message: `Status` }],
                      })(<Select
                        showSearch
                        filterOption={(input, option) =>
                          (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                        }
                        style={{ width: '80%' }}
                        placeholder="Please select"
                      >
                        {
                          status && status.length > 0 && status.filter(st => st.isActive && !isReservedStatus(st.name) && (!isClosedPendingInvoice || st.allowedInClosedPendingInvoice)).map((item) => {
                            const displayName = (() => {
                              if (item.name === 'ClosedPendingInvoice') {
                                return 'Closed - Pending Invoice';
                              } else if (item.name === 'ClosedPendingInvoiceReopen') {
                                return 'Closed - Pending Invoice - Reopened';
                              } else {
                                return item.name;
                              }
                            })();
                            return <Select.Option key={item._id} value={item._id}>{displayName}</Select.Option>
                          })
                        }
                      </Select>)
                      }
                      {/*{*/}
                      {/*filters['changeStatus'] && filters['changeStatus']['schema'] && filters['changeStatus']['schema']['status'].options.master ?*/}
                      {/*<MasterModal resource={'JobCard'}*/}
                      {/*item={filters['changeStatus']['schema']['status'].options.ref}*/}
                      {/*title={'CREATE'}/> : ''*/}
                      {/*}*/}
                    </Form.Item>

                    <Form.Item key={`details`} label={'Details'}>
                      {getFieldDecorator(`changeStatus['details']`, {
                        rules: [{ required: true, message: `Details` }],
                        initialValue: '',
                      })(<TextArea rows='5' />)
                      }
                    </Form.Item>
                  </div>
                </div>
              </> : ""
            }
          </Form>

        </Modal>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
